import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import CreateBranch from "./createBranch";
import ListBranch from "./listBranch";
import { styles } from "./styles";
import Header from "../../partials/header";

class ServiceBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddBranch: false,
      search: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
  }
  addNewBranch = () => {
    const { isAddBranch } = this.state;
    this.setState({ isAddBranch: !isAddBranch });
  };
  handleSearch(e) {
    const _this = this;
    this.setState({ search: e.target.value }, function () {
      _this.ListBranch.getBranchForOwner();
    });
  }
  render() {
    const { isAddBranch, search } = this.state;
    const { classes, t } = this.props;
    return (
      <div>
        {!isAddBranch ? (
          <Header
            session={t("sidebar_manage")}
            title={t("servicebranch_list_branch")}
            button={t("servicebranch_add_new_branch")}
            actionButton={this.addNewBranch}
          />
        ) : (
          <Header
            session={t("servicebranch_list_branch")}
            title={t("servicebranch_add_new_branch")}
            backIcon={true}
            actionBack={() => this.addNewBranch()}
          />
        )}
        <Grid container spacing={24}>
          {isAddBranch ? (
            <CreateBranch addNewBranch={this.addNewBranch} />
          ) : (
            <ListBranch
              onRef={(id) => (this.ListBranch = id)}
              search={search}
            />
          )}
        </Grid>
      </div>
    );
  }
}

ServiceBranch.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceBranch)
  )
);
